export default [
  {
    path: '/example',
    name: 'Example',
    component: () => import('../pages/ExamplePage.vue'),
    meta: { requiresAuth: true }
  }
]
